import { render, staticRenderFns } from "./WithdrawalModal.vue?vue&type=template&id=13caa6a1&scoped=true"
import script from "./WithdrawalModal.vue?vue&type=script&lang=ts"
export * from "./WithdrawalModal.vue?vue&type=script&lang=ts"
import style0 from "./WithdrawalModal.vue?vue&type=style&index=0&id=13caa6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13caa6a1",
  null
  
)

export default component.exports